<!-- The my-1 is needed for the outline -->
<div
  class="relative my-1 flex items-center gap-x-2 rounded-md p-1 pl-2 outline outline-transparent sm:pl-4"
  [ngClass]="{
    hidden: !vehicle(),
    'border border-zinc-100 hover:border-zinc-300': false,
    'bg-white': true,
  }">
  <textarea
    #chatInput
    data-testid="chat-input-textarea"
    rows="1"
    cols="30"
    name="qiraQuestion"
    class="flex-1 truncate !border-0 !bg-white !shadow-none !outline-none placeholder:truncate focus-visible:outline-none"
    placeholder="{{ this.hasMessages() ? ('chatInput.placeholder.withMessages' | transloco) : ('chatInput.placeholder.emptyThread' | transloco) }}"
    [(ngModel)]="message"
    (input)="adjustTextareaHeight($event)"
    (keydown)="onKeyDown($event)"
    [disabled]="disabled()"></textarea>

  <div class="ml-2 mr-2 flex items-center gap-x-2">
    <p-toggleSwitch [(ngModel)]="tabService.llmAnswersOn" data-testid="llm-toggle-switch" />
    <span class="text-sm max-md:hidden">{{ 'qiraAI.name' | transloco }}</span>
    <i class="pi pi-info-circle inline-block cursor-pointer text-zinc-500" [pTooltip]="infoTooltip" tooltipPosition="top" aria-hidden="true"></i>
  </div>

  <ng-template #infoTooltip>
    <div class="p-1">
      <h4 class="mb-1 text-base font-bold">
        {{ tabService.llmAnswersOn() ? ('qiraAI.enabled.heading' | transloco) : ('qiraAI.disabled.heading' | transloco) }}
      </h4>
      <p class="text-sm">
        {{ tabService.llmAnswersOn() ? ('qiraAI.enabled.description' | transloco) : ('qiraAI.disabled.description' | transloco) }}
      </p>
    </div>
  </ng-template>
  <p-button
    icon="pi pi-chevron-right"
    [attr.aria-label]="'global.submit' | transloco"
    data-testid="submit-question-btn"
    (onClick)="sendChatMessage()"
    [disabled]="!message" />
</div>
